import { useMemo } from 'react';
import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import { useIntl } from 'react-intl';
import settings from 'config/settings';
import { COUNT_TABLE_RECORDS } from 'constants/constants';
import {
  CustomerDataAnalyticsDocument,
  type CustomerDataAnalyticsQuery,
} from 'graphql/generated/graphql';
import type { TListItem } from 'graphql/types';

const { rootUrl } = settings;

/** The records of a page (the schema allows a null list and null items). */
export type TCustomerDataRecords = NonNullable<
  CustomerDataAnalyticsQuery['customerDataAnalytics']
>['customerDataRecords'];

export type TCustomerDataRecord = TListItem<TCustomerDataRecords>;

const useCustomerDataAnalytics = ({
  currentPage,
  filter,
}: {
  currentPage: number;
  filter: string;
}) => {
  const { locale } = useIntl();
  const { data, loading } = useQuery(CustomerDataAnalyticsDocument, {
    variables: {
      locale,
      rootUrl,
      filter,
      limit: COUNT_TABLE_RECORDS,
      offset: (currentPage - 1) * COUNT_TABLE_RECORDS,
    },
  });

  const customerDataRecords = useMemo(() => {
    const noRecords: TCustomerDataRecords = [];
    return get(data, 'customerDataAnalytics.customerDataRecords', noRecords);
  }, [data]);
  const total = get(data, 'customerDataAnalytics.count', 0);

  return { customerDataRecords, total, loading };
};

export default useCustomerDataAnalytics;
